import React from 'react'
import { Modal, modalVisibility, openModal, closeModal, ModalVisibilityProps } from 'sb-modal'

import messages from './messages'


type Props = {
  error: ReactIntlMessage | string
}

type ErrorModalProps = ModalVisibilityProps & Props

const ErrorModal: React.FunctionComponent<ErrorModalProps> = (props) => {
  const { error, closeModal, onClose } = props

  return (
    <Modal
      iconName="sadBird"
      title={messages.title}
      text={error}
      primaryButton={{
        title: messages.buttonTitle,
        onClick: () => {
          closeModal()
        },
      }}
      dataTestId="errorModal"
      onClose={onClose}
    />
  )
}

export const openErrorModal = (props: Props) => openModal('error', props)

export const closeErrorModal = () => closeModal('error')


export default modalVisibility('error', ErrorModal)
